import { render, staticRenderFns } from "./FeedbackPage.vue?vue&type=template&id=64e322f9&scoped=true"
import script from "./FeedbackPage.vue?vue&type=script&lang=js"
export * from "./FeedbackPage.vue?vue&type=script&lang=js"
import style0 from "./FeedbackPage.vue?vue&type=style&index=0&id=64e322f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e322f9",
  null
  
)

export default component.exports